<template>
  <!-- 底部数据统计 -->
  <div class="amountTotal">
    <div>
      <span class="amountItem">
        剩余应收金额：
        <span class="amount" v-thousand-separator="remainAmountTotal"></span>
        元
      </span>
      <span class="amountItem">
        本次收取金额：
        <span class="amount" v-thousand-separator="amountTotal"></span>
        元
      </span>
    </div>
    <div>
      <span>
        仍需收取金额：
        <span class="amount" v-thousand-separator="continueAmountTotal"></span>
        元
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionRecordAddAmount',
  props: {
    remainAmountTotal: {
      type: [String, Number],
      default: 0,
    },
    amountTotal: {
      type: [String, Number],
      default: 0,
    },
    continueAmountTotal: {
      type: [String, Number],
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.amountTotal {
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  .amountItem {
    margin-left: 10px;
  }

  .amount {
    font-weight: 500;
    font-size: 16px;
    color: #3d3d3d;
  }
}
</style>